import Swal from 'sweetalert2';
import { get_token} from "@/router";
import DisscussionComment from '@/components/DisscussionComment/DiscussionComment.vue';


export default {
  components:{
    DisscussionComment
  },
    data() {
        return ({
            topic_name: '',
            description: '', 
            disscussion_topics: [], 
            comment_modal_visible: false,
            report_data: null,
            editTopicData: {
              id: null,
              title: '',
              description: ''
            }
        })
    },
    mounted() {
        this.fetch_discussion_topics();
    },
    methods: {
        getToken() {
          return get_token();
        },
        create_discussion_topic() {   
              $.ajax({
                type: 'POST',
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_topic/`,
                data: JSON.stringify({
                    title: this.topic_name,
                    description: this.description,
                    portal_id: this.$route.params.portal_id,
                }),
                headers: {
                  'Authorization': `Token ${this.getToken()}`,
                },
                contentType: 'application/json', 
                success: (response) => {
                    this.disscussion_topics.unshift(response.data);
                    this.new_topic = ''; // Clear input
                },
                error: () => {
                  Swal.close();
                  Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Something went wrong. Please try again.',
                  });
                },
                complete: () => {
                  this.isSubmitting = false;
                }
              });
            },
        fetch_discussion_topics() {
              $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_topics/`,
                method: 'POST',
                headers: {
                  'Authorization': `Token ${this.getToken()}`,
                  'Content-Type': 'application/json'
                },
                data: JSON.stringify({filter_values:{ portal_id: this.$route.params.portal_id }}),
                success: (response) => {
                  var status = response.status
                  if (status == "success") {
                    this.disscussion_topics = response.data
                    Swal.close()
                  }
        
                },
        
                complete: () => {
                  this.isLoading = false;
                  Swal.close()
                }
              });
            },
        display_comment_modal(report_data) {
              this.report_data = report_data;
              this.comment_modal_visible = true;
            },
        edit_topic(topic) {
          this.editTopicData.id = topic.id;
          this.editTopicData.title = topic.name;
          this.editTopicData.description = topic.description;
          this.$nextTick(() => {
            $("#editTopicModal").modal("show");
          });
        },
      saveTopicEdits() {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_topic/`,
          method: 'POST',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          data: JSON.stringify(this.editTopicData),
          success: (response) => {
          var status = response.status
          if (status == "success") {
            this.disscussion_topics = response.data
            Swal.close()
          }
          },
        });
      },
      delete_topic(topic_id) {
              $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_topic/`,
                method: 'POST',
                headers: {
                  'Authorization': `Token ${this.getToken()}`,
                  'Content-Type': 'application/json'
                },
                data: JSON.stringify({topic_id:topic_id}),
                success: (response) => {
                var status = response.status
                if (status == "success") {
                  this.disscussion_topics = this.disscussion_topics.filter(topic =>topic.id !== topic_id);
                }
                },
              });
            },
      hide_comment(){
      this.comment_modal_visible = false;
      }

    },
}